module.exports = __webpack_public_path__ + "static/img/img_06.ac37144.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/113/img_06.jpg
// module id = N1cD
// module chunks = 1